































































import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Element, ElementStatusPhase, ElementStatusType, MilestoneDate, Product } from '@/models'
import {
  TRACING_PERCENTAGE_SITUATION_COMPLETED,
  TRACING_PERCENTAGE_SITUATION_GOOD,
  TRACING_SITUATION_DANGER,
  TRACING_SITUATION_COMPLETED,
  TRACING_SITUATION_GOOD,
  TRACING_SITUATION_WARNING,
  TRACING_SITUATION_ADVANCED
} from '@/utils/constants'
import { ActionTypes } from '@/store/action-types'
import moment from 'moment'
import { Utils } from '@/utils'

@Component({
  components: {
    ElementStatusFilesModal: () => import('@/components/modals/ElementStatusFilesModal.vue')
  }
})
export default class ElementTracingRow extends Vue {
  @Prop({ required: true, type: Object }) readonly product: Product
  @Prop({ required: true, type: Object }) readonly element: Element

  public TRACING_SITUATION_DANGER = TRACING_SITUATION_DANGER
  public TRACING_SITUATION_GOOD = TRACING_SITUATION_GOOD
  public TRACING_SITUATION_COMPLETED = TRACING_SITUATION_COMPLETED
  public TRACING_SITUATION_ADVANCED = TRACING_SITUATION_ADVANCED
  public TRACING_SITUATION_WARNING = TRACING_SITUATION_WARNING

  async created() {
    await this.loadElementStatusPhases()
  }

  get filesGroupedByElement() {
    return _.groupBy(this.element.elementStatusFiles, 'elementId')
  }

  get percentageByElements() {
    if (!this.filesGroupedByElement) {
      return null
    }

    const percentageByElements: any = {}
    for (const key in this.filesGroupedByElement) {
      const files = Utils.clearFilesFromElement(this.filesGroupedByElement[key])
      if (!files) {
        continue
      }

      const groupedByPhase = _.groupBy(files, 'elementStatusType.phase.elementStatusPhaseId')
      const arrayPercentages: any[] = []
      for (const phase of Object.keys(groupedByPhase)) {
        const filesByPhase = groupedByPhase[phase]

        const percentage = filesByPhase.length / files.length * 100
        arrayPercentages.push({ phase: phase, percentage: percentage })
      }
      percentageByElements[key] = arrayPercentages
    }

    return percentageByElements
  }

  get percentagesByPhaseTotal() {
    if (this.elementStatusPhases.length < 1) {
      return null
    }
    const elementValues = Object.values(this.percentageByElements)
    const phasesWithPercentagePlainArray = elementValues.flat()
    const groupedByPhase = _.groupBy(phasesWithPercentagePlainArray, 'phase')

    const percentagesByPhaseTotal = []
    for (const phase of Object.keys(groupedByPhase)) {
      const percentagesByPhase = groupedByPhase[phase]
      const sumTotalsFilesPonderated = percentagesByPhase.map((item: any) => item.percentage / 100).reduce((a, b) => { return a + b })
      const totalPercentageByPhase = sumTotalsFilesPonderated / elementValues.length * 100
      percentagesByPhaseTotal.push({ phase: phase, percentage: totalPercentageByPhase })
    }

    return percentagesByPhaseTotal
  }

  get percentagePhases() {
    if (!this.percentagesByPhaseTotal) {
      return null
    }

    const arrayPercentages: any[] = []
    for (const phase of this.elementStatusPhases) {
      const percentagesByPhase = this.percentagesByPhaseTotal.find((item: any) => item.phase === phase.elementStatusPhaseId)
      if (!percentagesByPhase || percentagesByPhase === undefined) {
        arrayPercentages.push({ phase: phase, percentage: 0 })
        continue
      }
      arrayPercentages.push({ phase: phase, percentage: percentagesByPhase.percentage })
    }
    return arrayPercentages
  }

  get percentagePhasesClear() {
    if (!this.percentagePhases) {
      return null
    }

    return this.percentagePhases.filter(item => item.percentage > 0)
  }

  get agregatedPercentagePhases() {
    if (!this.percentagePhases) {
      return null
    }

    const arrayPercentages: any[] = []
    let totalPercentage = 0
    for (const phase of this.elementStatusPhases.reverse()) {
      const percentagePhaseFind = this.percentagePhases.find(item => (item.phase as ElementStatusPhase).elementStatusPhaseId === phase.elementStatusPhaseId).percentage
      totalPercentage += percentagePhaseFind
      arrayPercentages.push({ phase: phase, percentage: totalPercentage })
    }
    return arrayPercentages
  }

  get milestoneDatesOrder(): MilestoneDate[] | null {
    if (!this.element.milestone || !this.element.milestone.milestoneDates) {
      return null
    }

    const milestoneDatesOrder = _.orderBy(this.element.milestone.milestoneDates, ['deadlineDate'])

    // Complete phase
    const milestoneDatesOrderFormated = []
    for (const milestoneDate of milestoneDatesOrder) {
      const phase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === milestoneDate.phase)
      milestoneDate.phaseObject = phase
      milestoneDatesOrderFormated.push(milestoneDate)
    }

    return milestoneDatesOrderFormated
  }

  get lastMilestoneDate(): MilestoneDate | null {
    if (!this.element.milestone || !this.milestoneDatesOrder) {
      return null
    }

    return this.milestoneDatesOrder[this.milestoneDatesOrder.length - 1]
  }

  get currentMilestoneDate(): MilestoneDate | null {
    if (!this.element.milestone || !this.milestoneDatesOrder) {
      return null
    }

    let currentMilestoneDate = this.lastMilestoneDate // Last item by default
    const todayDate = moment()
    for (const milestoneDate of this.milestoneDatesOrder) {
      const deadlineDateFormat = new Date(milestoneDate.deadlineDate)
      if (todayDate.isSameOrBefore(deadlineDateFormat, 'day')) {
        currentMilestoneDate = milestoneDate
        return currentMilestoneDate
      }
    }

    return currentMilestoneDate
  }

  get previousCurrentMilestoneDate(): MilestoneDate | null {
    if (!this.currentMilestoneDate || !this.milestoneDatesOrder) {
      return null
    }

    if (this.currentMilestoneDate.milestoneDateId === this.lastMilestoneDate?.milestoneDateId) {
      return null
    }

    const todayDate = moment()
    let previousMilestoneDate = null
    for (const milestoneDate of this.milestoneDatesOrder) {
      const deadlineDateFormat = new Date(milestoneDate.deadlineDate)
      if (todayDate.isSameOrBefore(deadlineDateFormat, 'day')) {
        return previousMilestoneDate
      }
      previousMilestoneDate = milestoneDate
    }

    return previousMilestoneDate
  }

  get currentMilestoneDatePhase(): ElementStatusPhase | null {
    if (!this.currentMilestoneDate) {
      return null
    }
    const phase = this.currentMilestoneDate.phase
    const elementStatusPhase = this.elementStatusPhases.find(item => item.elementStatusPhaseId === phase)
    if (elementStatusPhase) {
      return elementStatusPhase
    } else {
      return null
    }
  }

  get percentageCurrentMilestoneDatePhase(): number {
    if (!this.currentMilestoneDatePhase || this.currentMilestoneDatePhase === null) {
      return 0
    }
    // @ts-ignore: Object is possibly 'null'.
    const percentage = this.agregatedPercentagePhases.find(item => (item.phase as ElementStatusPhase).elementStatusPhaseId === this.currentMilestoneDatePhase.elementStatusPhaseId).percentage
    return Math.round(percentage)
  }

  get currentMilestoneDateDaysLeft() {
    if (!this.currentMilestoneDate) {
      return 0
    }
    return this.calculeMilestoneDateDaysLeft(this.currentMilestoneDate)
  }

  get percentageCurrentAchieved(): number {
    if (!this.currentMilestoneDate) {
      return 0
    }

    const currentPercentagePhase = this.percentageCurrentMilestoneDatePhase
    const objectivePercentage = this.currentMilestoneDate?.percentagePhase

    const percentage = Math.round(currentPercentagePhase * 100 / objectivePercentage)
    return percentage > 100 ? 100 : percentage
  }

  get elementStatusPhases(): ElementStatusPhase[] {
    const elementStatusPhases = this.$store.state.elementStatusPhases.filter((elementStatusPhase: ElementStatusType) =>
      elementStatusPhase.editorialProjectId === this.product.editorialProject &&
      elementStatusPhase.country === this.product.country)
    return _.orderBy(elementStatusPhases, ['orderPhase'])
  }

  private calculePercentageFromMilestoneDate(milestoneDate: MilestoneDate) {
    if (!this.agregatedPercentagePhases) {
      return null
    }

    const percentage = this.agregatedPercentagePhases.find(item => (item.phase as ElementStatusPhase).elementStatusPhaseId === milestoneDate.phase).percentage
    return Math.round(percentage)
  }

  private calculeSituationFromMilestoneDate(milestoneDate: MilestoneDate) {
    const percentage = this.calculePercentageFromMilestoneDate(milestoneDate)
    if (percentage == null) {
      return null
    }
    const daysLeft = this.calculeMilestoneDateDaysLeft(milestoneDate)
    let percentageAchieved = Math.round(percentage * 100 / milestoneDate.percentagePhase)
    percentageAchieved = percentageAchieved > 100 ? 100 : percentageAchieved

    if (percentageAchieved >= TRACING_PERCENTAGE_SITUATION_COMPLETED) {
      if (daysLeft <= 0) {
        return TRACING_SITUATION_COMPLETED
      } else {
        return TRACING_SITUATION_ADVANCED
      }
    }

    if (daysLeft <= 0) {
      return TRACING_SITUATION_DANGER
    } else if (daysLeft > 6) {
      return TRACING_SITUATION_GOOD
    } else {
      if (percentageAchieved >= TRACING_PERCENTAGE_SITUATION_GOOD && percentageAchieved < TRACING_PERCENTAGE_SITUATION_COMPLETED) {
        return TRACING_SITUATION_GOOD
      } else if (percentageAchieved < TRACING_PERCENTAGE_SITUATION_GOOD) {
        return TRACING_SITUATION_WARNING
      }
    }
    return TRACING_SITUATION_DANGER
  }

  private calculeMilestoneDateDaysLeft(milestoneDate: MilestoneDate) {
    if (!milestoneDate) {
      return 0
    }
    const currentDate = moment(milestoneDate?.deadlineDate)
    const todayDate = moment().startOf('day')
    return currentDate.diff(todayDate, 'days')
  }

  private async loadElementStatusPhases() {
    await this.$store.dispatch(ActionTypes.GET_ELEMENT_STATUS_PHASES, { editorialProjectId: this.product.editorialProject, country: this.product.country })
  }

  private openModal() {
    this.$bvModal.show('elementStatusFilesModal' + this.element.id)
  }
}
